import styled from "@emotion/styled";
import { GrIconButton, GrSelect, GrSelectOptionObject, GrStack, palette } from "@jnpmedi/grebob";
import { useFileDetailViewerContext } from "@newHooks/context/viewer/fileDetailViewer.context";
import { testKey } from "@maven-rest/automationTest/e2e/docs/testKey";

export function FileDetailViewerZoomButton() {
  const { zoom, setZoom } = useFileDetailViewerContext();

  const MIN_ZOOM = 0.4;
  const MAX_ZOOM = 1.5;
  const scale = (sign: "+" | "-", val: number): number => Number(Math.round((sign === "+" ? val + 0.1 : val - 0.1) * 10) / 10);
  const selectOptions: GrSelectOptionObject<string>[] = [
    {
      value: "40%",
      label: "40%",
    },
    {
      value: "70%",
      label: "70%",
    },
    {
      value: "100%",
      label: "100%",
    },
    {
      value: "130%",
      label: "130%",
    },
    {
      value: "150%",
      label: "150%",
    },
  ];

  const handleZoomIn = () => {
    typeof zoom === "number" && zoom < MAX_ZOOM && setZoom(scale("+", zoom));
  };

  const handleZoomOut = () => {
    typeof zoom === "number" && zoom > MIN_ZOOM && setZoom(scale("-", zoom));
  };

  return (
    <FileDetailViewerZoomButtonWrapper>
      <GrIconButton
        className={testKey.common.docsPdfViewerFooterZoomOutIconButton}
        iconType="minus"
        size={14}
        onClick={handleZoomOut}
        disabled={typeof zoom !== "number" || zoom <= MIN_ZOOM}
      />
      <GrSelect<string, false, false>
        size="small"
        variant="text"
        style={{
          width: "84px",
        }}
        value={`${typeof zoom === "number" ? Number(Math.round(zoom * 100)) : ""}%`}
        options={selectOptions}
        onChange={(_, v) => {
          setZoom(Number(v.replace("%", "")) / 100);
        }}
      />
      <GrIconButton
        className={testKey.common.docsPdfViewerFooterZoomInIconButton}
        iconType="plus"
        size={14}
        onClick={handleZoomIn}
        disabled={typeof zoom !== "number" || zoom >= MAX_ZOOM}
      />
    </FileDetailViewerZoomButtonWrapper>
  );
}

const FileDetailViewerZoomButtonWrapper = styled(GrStack)`
  background-color: ${palette["white"]};
  padding: 4px;
  gap: 4px;
  border: 1px solid ${palette["grey025"]};
  border-radius: 6px;
  pointer-events: auto;

  @media (max-width: 768px) {
    flex-direction: column-reverse;
    .GrSelect-wrapper {
      display: none;
    }
  }
`;
